export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "How It Works", path: "/how-it-works" },
  { label: "Safety", path: "/safety" },
  { label: "Community Rules", path: "/community-rules" },
  { label: "FAQ", path: "/faq" },
  { label: "Contact", path: "/contact" },
];

export const LEGAL_LINKS = [
  { label: "Privacy Policy", path: "/privacy" },
  { label: "Terms of Use", path: "/terms" },
];

export const CONTACT = {
  company: "Interlaced Social LLC",
  brand: "Doublelist",
  address: "2261 Market St. #4626, San Francisco, CA 94114, USA",
  phone: "+1 731-298-6768",
  email: "space@interlacedsociial.com",
};
